// src/components/infografia/properties/PropertiesPanel.jsx
import React from 'react';
import TextProperties from './TextProperties';
import ImageProperties from './ImageProperties';
import QRCodeProperties from './QRCodeProperties';
import ShapeProperties from './ShapeProperties';
import IconProperties from './IconProperties';
import LayerControls from './LayerControls';

const PropertiesPanel = ({ element, onUpdate, onDelete, marcaId, infografiaId, onOpenImageSearch, marca, onOpenIconSelector }) => {
    if (!element) return null;

    const renderProperties = () => {
        switch (element.tipo) {
            case 'texto':
                return <TextProperties element={element} onUpdate={onUpdate} />;
            case 'imagen':
                return <ImageProperties element={element} onUpdate={onUpdate} marcaId={marcaId} infografiaId={infografiaId} onOpenImageSearch={onOpenImageSearch} />;
            case 'qr':
                return <QRCodeProperties element={element} onUpdate={onUpdate} marcaId={marcaId} marca={marca} />;
            case 'icono':
                return <IconProperties element={element} onUpdate={onUpdate} onOpenIconSelector={onOpenIconSelector} />;
            case 'forma':
                return <ShapeProperties element={element} onUpdate={onUpdate} />;
            default:
                return (
                    <div className="p-4 text-center text-gray-500">
                        <p>Propiedades no disponibles para este elemento</p>
                    </div>
                );
        }
    };

    return (
        <div className="p-6">
            <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-semibold text-gray-900">
                    Propiedades del Elemento
                </h3>
                {onDelete && (
                    <button
                        onClick={onDelete}
                        className="px-3 py-1 text-sm bg-red-500 text-white rounded hover:bg-red-600 transition-colors"
                        title="Eliminar elemento"
                    >
                        Eliminar
                    </button>
                )}
            </div>
            <div className="text-sm text-gray-600 mb-4">
                Tipo: <span className="font-medium capitalize">{element.tipo}</span>
            </div>

            {/* Control de capas - para todos los elementos */}
            <div className="mb-6 pb-6 border-b border-gray-200">
                <LayerControls
                    element={element}
                    onLayerChange={(action) => {
                        onUpdate({ layerAction: action });
                    }}
                />
            </div>

            {renderProperties()}
        </div>
    );
};

export default PropertiesPanel;

